import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'userStatus',
    standalone: false
})
export class UserStatusPipe implements PipeTransform {
    transform(items: any[], status: string): any {
        if (status === '') {
            return items;
        }
        return items.filter((it) => {
            if (it.status === status) {
                return it;
            }
        });
    }
}
